import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { TokenAdminService } from 'src/app/core/token/token-admin.service';
import { AdminUserService } from 'src/app/core/user/admin-user.service';

import { LayoutUtilsService } from './layout-utils.service';
import { TokenService } from 'src/app/core/token/token.service';
import { UserService } from 'src/app/core/user/user.service';
import { UserModel } from 'src/app/core/models/user.model';
import { AdminUserModel } from 'src/app/pagesAdmin/admin-users/admin-user.model';
import { QueryParamsService } from 'src/app/core/services/query-params.service';

@Injectable()
export class InterceptService implements HttpInterceptor {
  constructor(
    private tokenService: TokenService,
    private tokenAdminService: TokenAdminService,
    private adminUserService: AdminUserService,
    private userService: UserService,
    private layoutUtilsService: LayoutUtilsService,
    private queryParamsService: QueryParamsService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const headers: any = {};

    if (
      this.tokenService.hasToken() &&
      !this.userService.isTokenExpired() &&
      this.userService.hasRole(UserModel.ROLES.ROLE_USER.CODE) &&
      window.location.hash.indexOf('admin') === -1
    ) {
      headers.Authorization = `Bearer ${this.tokenService.getToken()}`;
    }

    if (
      this.tokenAdminService.hasToken() &&
      !this.userService.isTokenExpired() &&
      this.adminUserService.hasRole(
        AdminUserModel.ROLES.ROLE_ADMINISTRATOR.CODE
      ) &&
      window.location.hash.indexOf('admin') !== -1
    ) {
      headers.Authorization = `Bearer ${this.tokenAdminService.getToken()}`;

      // if (request.method === 'GET') {
      //   const url = new URL(request.urlWithParams);
      //   if (url.searchParams.size > 0) {
      //     this.queryParamsService.setQueryParamItem(
      //       request.urlWithParams.split('?')[0].split('/api/')[1],
      //       url.searchParams
      //     );
      //   }
      // }
    }

    const params = {} as any;

    if (Object.keys(headers).length > 0 || Object.keys(params).length > 0) {
      const obj = {} as any;

      if (Object.keys(headers).length > 0) {
        obj['setHeaders'] = headers;
      }

      if (Object.keys(params).length > 0) {
        obj['setParams'] = params;
      }

      request = request.clone(obj);
    }

    return next.handle(request).pipe(
      tap(
        (event) => {
          if (event instanceof HttpResponse) {
            // console.log('all looks good');
            // http response status code
            // console.log(event.status);
          }
        },
        (err) => {
          let hasToken = false;

          if (request.url.indexOf('admin') === -1 && err.status === 401) {
            this.userService.logout();
            //hasToken = true;
          }

          if (request.url.indexOf('admin') !== -1 && err.status === 401) {
            this.adminUserService.logout();
            hasToken = true;
          }

          if (
            hasToken &&
            request.method === 'GET' &&
            (err.status.toString().substring(0, 1) === '5' ||
              (err.status.toString().substring(0, 1) === '4' &&
                err.status !== 401 &&
                err.status !== 403))
          ) {
            this.layoutUtilsService.showActionNotification({
              title: 'Houve um erro na leitura dos dados',
              icon: 'error',
            });
          }

          // if (err.status === 401 && request.url.indexOf('login') === -1) {
          //   setTimeout(() => {
          //     window.location.reload();
          //   });
          // }
        }
      )
    );
  }
}
